export const CloverTerminalTokenizationOutcome = {
    TOKEN_CREATED: 'token_created',
    CANCELED: 'canceled',
    UNSUPPORTED_TERMINAL: 'unsupported_terminal',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CloverTerminalTokenizationOutcome =
    (typeof CloverTerminalTokenizationOutcome)[keyof typeof CloverTerminalTokenizationOutcome];

export interface CloverTerminalTokenizationRequestHeaders {
    readonly deviceId: string;
    readonly idempotencyKey?: string;
    readonly posId: string;
    readonly userAgent: string;
    readonly timeoutSeconds?: number;
}

export type CloverCardEntryMethod = 'MAG_STRIPE' | 'EMV' | 'NFC' | 'MANUAL' | 'DEFAULT';

export interface CloverTerminalTokenizationRequestBody {
    readonly cardEntryMethods?: readonly CloverCardEntryMethod[];
    readonly tokenType: 'ECOMM_COMPAT';
}

export interface CloverTerminalTokenizationRequestDetails {
    readonly method: 'POST';
    readonly path: '/v1/card/tokens';
    readonly headers: CloverTerminalTokenizationRequestHeaders;
    readonly body: CloverTerminalTokenizationRequestBody;
}

export interface CloverTerminalTokenizationSuccessBody {
    readonly expirationDate?: string;
    readonly first6?: string;
    readonly last4?: string;
    readonly name?: string;
    readonly token: string;
    readonly tokenType: 'ECOMM_COMPAT';
}

export interface CloverTerminalTokenizationErrorBody {
    readonly message: string;
    readonly type: string;
    readonly code?: string;
    readonly requestId?: string;
    readonly requestType?: string;
}

export type CloverTerminalTokenizationResponseDetails =
    | {
          readonly outcome: typeof CloverTerminalTokenizationOutcome.TOKEN_CREATED;
          readonly httpStatus: 200;
          readonly body: CloverTerminalTokenizationSuccessBody;
      }
    | {
          readonly outcome: typeof CloverTerminalTokenizationOutcome.CANCELED;
          readonly httpStatus: 209;
          readonly body: CloverTerminalTokenizationErrorBody;
      }
    | {
          readonly outcome: typeof CloverTerminalTokenizationOutcome.UNSUPPORTED_TERMINAL;
          readonly httpStatus: 501;
          readonly body: CloverTerminalTokenizationErrorBody;
      }
    | {
          readonly outcome: typeof CloverTerminalTokenizationOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      };

export type CloverTerminalTokenizationResult =
    | {
          readonly status: typeof CloverTerminalTokenizationOutcome.TOKEN_CREATED;
          readonly gatewayToken: string;
          readonly expiry?: string;
          readonly cardholderName?: string;
          readonly first6?: string;
          readonly last4?: string;
          readonly singleUseToken: false;
          readonly tokenType: 'ECOMM_COMPAT';
      }
    | {
          readonly status:
              | typeof CloverTerminalTokenizationOutcome.CANCELED
              | typeof CloverTerminalTokenizationOutcome.UNSUPPORTED_TERMINAL
              | typeof CloverTerminalTokenizationOutcome.MALFORMED_RESPONSE;
          readonly message: string;
      };
